module.exports = __webpack_public_path__ + "f32dd0096c8516320c469640256b3d48.svg";